const HEX_W = 80;
const HEX_H = 70;
const COL_STEP = HEX_W * 0.75;
const ROW_STEP = HEX_H;

const hexPoints = (cx, cy) => {
  const w2 = HEX_W / 2;
  const h2 = HEX_H / 2;
  const q = HEX_W / 4;
  return [
    [cx - w2 + q, cy - h2],
    [cx + w2 - q, cy - h2],
    [cx + w2, cy],
    [cx + w2 - q, cy + h2],
    [cx - w2 + q, cy + h2],
    [cx - w2, cy],
  ]
    .map(([x, y]) => `${x.toFixed(2)},${y.toFixed(2)}`)
    .join(" ");
};

const GOLD_ACCENTS = [
  [2, 3],
  [6, 11],
  [14, 5],
  [21, 14],
  [28, 7],
  [33, 12],
];

const NavigatorBackground = () => {
  const W = 2400;
  const H = 2000;
  const cols = Math.ceil(W / COL_STEP) + 2;
  const rows = Math.ceil(H / ROW_STEP) + 2;
  const cells = [];

  for (let col = 0; col < cols; col += 1) {
    for (let row = 0; row < rows; row += 1) {
      const cx = col * COL_STEP;
      const cy = row * ROW_STEP + (col % 2 === 1 ? ROW_STEP / 2 : 0);
      cells.push({ key: `${col}-${row}`, cx, cy, col, row });
    }
  }

  const isGold = (col, row) => GOLD_ACCENTS.some(([c, r]) => c === col && r === row);

  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 overflow-hidden"
      style={{ zIndex: 0 }}
    >
      <svg
        width="100%"
        height="100%"
        viewBox={`0 0 ${W} ${H}`}
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          {cells.map(({ key, cx, cy, col, row }) =>
            isGold(col, row) ? null : (
              <polygon
                key={key}
                points={hexPoints(cx, cy)}
                fill="none"
                stroke="#1B2A4A"
                strokeWidth={0.6}
                opacity={0.07}
              />
            )
          )}
        </g>

        <g>
          {cells
            .filter(({ col, row }) => isGold(col, row))
            .map(({ key, cx, cy }) => (
              <polygon
                key={`gold-${key}`}
                points={hexPoints(cx, cy)}
                fill="none"
                stroke="#FFD100"
                strokeWidth={0.8}
                opacity={0.12}
              />
            ))}
        </g>

        <line x1={0} y1={80} x2={W} y2={80} stroke="#FFD100" strokeWidth={1} opacity={0.2} />
        <line
          x1={0}
          y1={H - 80}
          x2={W}
          y2={H - 80}
          stroke="#FFD100"
          strokeWidth={1}
          opacity={0.2}
        />
        <line x1={40} y1={0} x2={40} y2={H} stroke="#1B2A4A" strokeWidth={0.5} opacity={0.08} />
      </svg>
    </div>
  );
};

export default NavigatorBackground;
